import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { pdf } from "@react-pdf/renderer";
import FeesStructurePDF11 from "./FeesStructurePdf11";
import CryptoJS from "crypto-js";

function FeesStructure11() {
  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isPreviewed, setIsPreviewed] = useState(false);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateaccountstoken");
  const [class11DeveloperMode, setClass11DeveloperMode] = useState("");

  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/FetchConfigurationData`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-Private-Key": tokeng,
            },
          }
        );

        const data = await response.json();
        if (response.ok) {
          const configData = data?.data;
          setClass11DeveloperMode(configData.cL_11_DEVELOPER_MODE);
        } else {
          Swal.fire("Error", data.message || "Invalid response", "error");
        }
      } catch (error) {
        Swal.fire("Error", "Something went wrong. Try again later.", "error");
      }
    };

    fetchConfigData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${config.API_BASE_URL}/FetchFeesStructure_CL11`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");
      const data = await response.json();
      console.log(data);
      setTableData(data.data.feesStructureDataCL11_list);
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  const sendEmail = async () => {
    try {
      const tokeng = generateOneTimeToken();
      const pdfBlob = await pdf(
        <FeesStructurePDF11 tableData={tableData} />
      ).toBlob();
      const pdfFile = new File([pdfBlob], "Class-XI-Fees-Structure.pdf", {
        type: "application/pdf",
      });

      // 1st Email
      const formData1 = new FormData();
      if (class11DeveloperMode === "NO") {
        formData1.append("To", "itcell.jac@gmail.com");
        formData1.append("Bcc", "parikshadata@gmail.com");
      } else {
        formData1.append("To", "sumit@cludotechnology.in");
        formData1.append("Bcc", "prosenjit.maji@cludotechnology.in");
      }
      formData1.append("Subject", "Updated Fees Structure - CLASS XI");
      formData1.append(
        "Message",
        "Please find attached the updated Class XI Fees Structure PDF."
      );
      formData1.append("Attachments", pdfFile);

      const response1 = await fetch(`${config.API_BASE_URL}/SendMail1`, {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          "X-Private-Key": tokeng,
        },
        body: formData1,
      });

      const data1 = await response1.json();

      if (!(response1.ok && (data1.success || data1.status === "ok"))) {
        Swal.fire("Error", data1.message || "Failed to send email.", "error");
        return false;
      }

      // const formData2 = new FormData();
      // if (class11DeveloperMode === "NO") {
      //   formData2.append("TO", "parikshadata@gmail.com");
      // } else {
      //   formData2.append("TO", "nilotpal@cludotechnology.in");
      // }
      // formData2.append("SUBJECT", "Updated Fees Structure - CLASS XI");
      // formData2.append(
      //   "MESSAGE",
      //   "Please find attached the updated Class XI Fees Structure PDF."
      // );
      // formData2.append("ATTACHMENTS", pdfFile);

      // const response2 = await fetch(`${config.API_BASE_URL}/SendMail1`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     "X-Private-Key": tokeng,
      //   },
      //   body: formData2,
      // });

      // const data2 = await response2.json();

      // if (!(response2.ok && (data2.success || data2.status === "ok"))) {
      //   Swal.fire(
      //     "Error",
      //     data2.message || "Failed to send 2nd email.",
      //     "error"
      //   );
      //   return false;
      // }
    } catch (error) {
      console.error("Error sending email:", error.message);
      Swal.fire("Error", error.message || "Something went wrong", "error");
      return false;
    }
  };

  const handleInputChange = (e, key, index) => {
    const value = e.target.value;
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    const newData = [...tableData];
    newData[index][key] = value;

    const odppm = parseFloat(newData[index].odppM_FEES) || 0;
    const reg = parseFloat(newData[index].registratioN_FEES) || 0;
    const migration = parseFloat(newData[index].migratioN_FEES) || 0;
    const collegePerm = parseFloat(newData[index].collegE_PERMISSION_FEES) || 0;
    const exam = parseFloat(newData[index].clasS_11_EXAMINATION_FEES) || 0;

    const lateReg = parseFloat(newData[index].latE_FINE_REGISTRATION) || 0;
    const lateMigration = parseFloat(newData[index].latE_FINE_MIGRATION) || 0;
    const lateCollegePerm =
      parseFloat(newData[index].latE_FINE_COLLEGE_PERMISSION) || 0;

    const beforeLateTotal = odppm + reg + migration + collegePerm + exam;
    const afterLateTotal =
      beforeLateTotal + lateReg + lateMigration + lateCollegePerm;

    newData[index].beforE_LATE_TOTAL_FEES = beforeLateTotal.toFixed(2);
    newData[index].afteR_LATE_TOTAL_FEES = afterLateTotal.toFixed(2);

    setTableData(newData);
  };

  // Preview button click
  const handleClickPreview = () => {
    const hasEmpty = tableData.some(
      (item) =>
        !item.odppM_FEES ||
        !item.registratioN_FEES ||
        !item.migratioN_FEES ||
        !item.collegE_PERMISSION_FEES ||
        !item.clasS_11_EXAMINATION_FEES ||
        !item.latE_FINE_REGISTRATION ||
        !item.latE_FINE_MIGRATION ||
        !item.latE_FINE_COLLEGE_PERMISSION
    );

    if (hasEmpty) {
      Swal.fire(
        "Validation Error",
        "All fields are required. Please fill in all values.",
        "warning"
      );
      return;
    }

    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(true);
      setLoading(false);
    }, 500);
  };

  const handleClickEdit = () => {
    setLoading(true);
    setTimeout(() => {
      setIsPreviewed(false);
      setLoading(false);
    }, 500);
  };

  const handleUpdateClick = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to edit it once submitted",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const payload = tableData.map((item) => ({
          autO_CODE: item.autO_CODE,
          odppM_FEE: item.odppM_FEES || 0,
          registratioN_FEES: item.registratioN_FEES || 0,
          migratioN_FEES: item.migratioN_FEES || 0,
          collegE_PERMISSION_FEES: item.collegE_PERMISSION_FEES || 0,
          clasS_11_EXAMINATION_FEES: item.clasS_11_EXAMINATION_FEES || 0,
          beforE_LATE_TOTAL_FEES: item.beforE_LATE_TOTAL_FEES || 0,
          latE_FINE_REGISTRATION: item.latE_FINE_REGISTRATION || 0,
          latE_FINE_MIGRATION: item.latE_FINE_MIGRATION || 0,
          latE_FINE_COLLEGE_PERMISSION: item.latE_FINE_COLLEGE_PERMISSION || 0,
          afteR_LATE_TOTAL_FEES: item.afteR_LATE_TOTAL_FEES || 0,
        }));

        try {
          setLoading(true);
          const response = await fetch(
            `${config.API_BASE_URL}/UpdateFeesDataCl11`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(payload),
            }
          );
          const data = await response.json();
          if (response.ok) {
            Swal.fire(
              "Success",
              "Fees structure updated successfully!",
              "success"
            ).then(async () => {
              await handleDownload();
              await sendEmail();
              await fetchData();
            });
          } else {
            Swal.fire(
              "Error",
              data.message || "Something went wrong.",
              "error"
            );
          }
        } catch (error) {
          console.error("Error updating fees:", error);
          Swal.fire("Error", "Something went wrong while updating.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleDownload = async () => {
    try {
      const blob = await pdf(
        <FeesStructurePDF11 tableData={tableData} />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Class-XI-Fees-Structure.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: "File has been downloaded successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("PDF download failed:", error);
      Swal.fire("Error", "Something went wrong while downloading", "error");
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-1">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-inr"></i>&nbsp; Class XI Fees Structure
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        href="accounts-dashboard"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/intermediate-accounts-dashboard-class-xi");
                        }}
                      >
                        Home&nbsp;
                      </a>
                    </li>
                    <li className="active">Class XI Fees Structure</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {tableData.length > 0 &&
                      tableData.some(
                        (item) => item.updatE_STATUS === "YES"
                      ) && (
                        <div className="d-flex justify-content-end p-2">
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={handleDownload}
                          >
                            <i className="fa fa-download me-1"></i> Download Pdf
                          </button>
                        </div>
                      )}
                    <div className="table-responsive">
                      <table className="table table-bordered mb">
                        <thead>
                          <tr className="table-info">
                            <th>#</th>
                            {/* <th>Description</th> */}
                            <th>Category</th>
                            <th>Gender</th>
                            <th>Board</th>
                            <th>ODPPM Fee</th>
                            <th>Registration Fee</th>
                            <th>Migration Fee</th>
                            <th>College Perm Fee</th>
                            <th>Examination Fee</th>
                            <th>Before Late Total Fee</th>
                            <th>Late Fine Reg</th>
                            <th>Late Fine Migration</th>
                            <th>Late Fine College Perm</th>
                            <th>After Late Total Fee</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.length > 0 ? (
                            tableData.map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td
                                    style={{
                                      backgroundColor:
                                        index % 2 === 0
                                          ? "#e4e4e4"
                                          : "transparent",
                                    }}
                                    rowSpan={2}
                                  >
                                    {index + 1}
                                  </td>
                                  {/* <td>{item.description}</td> */}
                                  <td
                                    style={{
                                      backgroundColor:
                                        index % 2 === 0
                                          ? "#e4e4e4"
                                          : "transparent",
                                    }}
                                    colSpan={13}
                                  >
                                    <b>Description : </b>
                                    {item.description}
                                  </td>
                                </tr>
                                <tr key={index + 0.1}>
                                  <td>{item.category}</td>
                                  <td>{item.gender}</td>
                                  <td>{item.board}</td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.odppM_FEES}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "odppM_FEES",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.registratioN_FEES}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "registratioN_FEES",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.migratioN_FEES}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "migratioN_FEES",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.collegE_PERMISSION_FEES}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "collegE_PERMISSION_FEES",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.clasS_11_EXAMINATION_FEES}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "clasS_11_EXAMINATION_FEES",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.beforE_LATE_TOTAL_FEES}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.latE_FINE_REGISTRATION}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "latE_FINE_REGISTRATION",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.latE_FINE_MIGRATION}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "latE_FINE_MIGRATION",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.latE_FINE_COLLEGE_PERMISSION}
                                      onChange={(e) =>
                                        handleInputChange(
                                          e,
                                          "latE_FINE_COLLEGE_PERMISSION",
                                          index
                                        )
                                      }
                                      disabled={
                                        item.updatE_STATUS === "YES" ||
                                        isPreviewed
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-right"
                                      value={item.afteR_LATE_TOTAL_FEES}
                                      disabled
                                    />
                                  </td>
                                </tr>
                              </>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="14"
                                className="text-center text-muted"
                              >
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>

                        <tfoot>
                          <tr>
                            <th colSpan="14" className="text-end">
                              {tableData.length > 0 ? (
                                tableData.some(
                                  (item) => item.updatE_STATUS === "YES"
                                ) ? (
                                  <p className="text-danger text-center mt-3">
                                    Fees Structure already updated. Changes are
                                    not allowed.
                                  </p>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <marquee className="fomarquee">
                                      Fees Structure can only be updated at
                                      once.No further changes will be applicable
                                      after submitting.
                                    </marquee>

                                    {isPreviewed ? (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-warning btn-sm ms-2"
                                          onClick={handleClickEdit}
                                        >
                                          <i className="fa fa-edit me-1"></i>{" "}
                                          Edit
                                        </button>

                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm ms-2"
                                          onClick={handleUpdateClick}
                                        >
                                          <i className="fa fa-save"></i>
                                          &nbsp;Submit
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-info btn-sm ms-2"
                                        onClick={handleClickPreview}
                                      >
                                        <i className="fa fa-eye me-1"></i>{" "}
                                        Preview
                                      </button>
                                    )}
                                  </div>
                                )
                              ) : null}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default FeesStructure11;
